import './App.css';
import {
  BrowserRouter as Router,
  Routes,
  Route
} from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './components/Home';
import About from './components/About';
import NoteState from './context/notes/NoteState';
import Alert from './components/Alert';
import Signup from './components/Signup';
import Login from './components/Login';
import Welcome from './components/Welcome';
import { useState } from 'react';

function App() {

  const [alert,setAlert] = useState(null);

  const showAlert=(message,type)=>{
    setAlert({
      msg: message,
      type: type
    })
    setTimeout(() => {
      setAlert(null);
    }, 1500);
  }


  return (
    <>
      <NoteState>
        <Router>
          <Navbar />
          <Alert alert={alert}/>
          <div className="container">
          <Routes>
            <Route key={'*'} path='*' element={<Welcome />} />
            <Route key={'home'} exact path='/home' element={<Home showAlert={showAlert} />} />
            <Route key={'about'} exact path='/about' element={<About />} />
            <Route key={'login'} exact path='/login' element={<Login showAlert={showAlert} />} />
            <Route key={'signup'} exact path='/signup' element={<Signup showAlert={showAlert} />} />
          </Routes>
          </div>
        </Router>
      </NoteState>
    </>
  );
}

export default App;
